import { render, staticRenderFns } from "./LayoutControl.vue?vue&type=template&id=32183129&scoped=true&"
import script from "./LayoutControl.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LayoutControl.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LayoutControl.vue?vue&type=style&index=0&id=32183129&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32183129",
  null
  
)

export default component.exports